import { Resource } from '@centers/interfaces/resource';
import { PriceCategory } from '@contacts/interfaces/price-category';
import { Booking } from './booking';
import { Article } from '@accounting/interfaces/article';
import { Discipline } from '@centers/interfaces/discipline';
import { OptionGroupsStructure } from '@core/interfaces/option-group';
import { Order } from '@accounting/interfaces/order';
import { Contact } from '@contacts/interfaces/contact';
import { MultiplayerBooking } from '@bookings/interfaces/multiplayer-booking';
import { AccessControlBadge } from '@access-control/interfaces/access-control-badge';

export class BookingEvent {
  id: number;
  center_id: number; // 1
  discipline: Discipline;
  discipline_id: number; // 1,
  booking_id: number; // 1,
  booking: Booking;
  resource_id: number; // 1,
  contact: Contact;
  contact_id: number; // 1,
  price_category?: PriceCategory;
  price_category_id: number; // 1,
  code: string; // "AA0001",
  name: string; // "Event 1",
  status: string; // "active",
  date: string; // "2020-05-12",
  start_time: string; // "20:00:00",
  end_time: string; // "21:00:00",
  comment: string; // "Ceci est un test"
  event_price: number;
  conflicts?: BookingEvent[];
  resource?: Resource;
  update_orders: boolean;
  reductionArticles: [];
  action_for_update: string;
  action_for_conflicts: string;
  action_for_orders: string;
  own_to_repetitive_booking: boolean;
  booking_type?: string;
  article?: Article;
  article_id: number;
  booking_options?: OptionGroupsStructure;
  booking_options_for_organization?: OptionGroupsStructure;
  orders?: Order[];
  notify_by_email?: boolean;
  orders_status?: string;
  eventPrice?: number;
  action?: string;
  real_number_of_participants?: string;
  incident_to_report?: boolean;
  incident_type?: IncidentType;
  incident_description?: string;
  is_multiplayer: boolean;
  multiplayer_data?: MultiplayerBooking;
  booking_event_multiplayer_data?: MultiplayerBooking; // Fixme this is a duplicate of the previous property, rationalize
  access_control_badge_id?: number;
  access_control_badge?: AccessControlBadge;
  accessControlBadge?: AccessControlBadge;
  paid_amount?: number;
}

export interface PublicBookingEventData {
  id: number;
  start_time: string;
  date: string;
  end_time: string;
  resourceId: number;
  resource: string;
  discipline: string;
  number_of_players: number;
  is_multiplayer: boolean;
}

export enum IncidentType {
  InfrastructureDamage = 'infra_damage',
  ParticipantIssue = 'participant_issue',
  Other = 'other',
}

export interface BookingEventIncidentReport {
  id: number;
  real_number_of_participants: number;
  real_number_of_participants_description: string;
  incident_to_report: boolean;
  incident_type?: IncidentType;
  incident_description?: string;
}
